<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickSetup()">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickSetup()">Variable Pay</span> / <span
            [style.color]="buttonColorName">Logs</span></label>
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-15">
      <div class="center-content mt-10">
        <div>
          <p class="fs-14 mb-10">Year</p>
          <mat-form-field class="w-150 mat-height40 mat-input-style">
            <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)">
              <mat-option [value]="item.year"
                *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <p class="fs-14 ml-40 mb-10">Change Type</p>
          <mat-form-field class="w-150 ml-40 mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="selectChangeType"
              (selectionChange)="onSelectChangeType($event)">
              <mat-option value="All">All</mat-option>
              <mat-option value="Variable Pay Setup">Setup</mat-option>
              <mat-option value="Variable Pay Input">Variable Pay Input</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <div class="table-layout">
    <ion-grid class="p-0">
      <div class="tableBox mt-10">
        <ion-row class="p-0">
          <table class="hover">
            <thead class="bg-gray">
              <tr>
                <th class="fs-14 font_bold cl-black" *ngFor="let item of gridData.columnInfo">
                  <div class="verticle-center icon-style">{{item.label}}
                    <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="sortAsending(item.sortingName)">arrow_drop_up</i>
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="sortDesending(item.sortingName)">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white" *ngIf="renderData.length !== 0">
              <tr *ngFor="let item of renderData;let i=index">
                <ng-container *ngFor="let innerItem of item">
                  <td *ngIf="innerItem.key !== 'id'" class="fs-16 font_regular">
                    <span>{{innerItem.value}}</span>
                    <a *ngIf="innerItem.value == 'uploadingTheContract' &&
                    (innerItem.key== 'oldValue' || innerItem.key == 'newValue')" [href]="innerItem.value"
                      target="_blank">Contract</a>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </ion-row>
      </div>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="display-end">
        <ul class="dt_pagination">
          <ion-row class="float-right pgintn">
            <li class="fs-16">{{currentPage}}</li>
            <span class="fs-14 font_regular p-10">of {{gridData.totalNoOfPages}}</span>
            <li class="fs-24 cp" (click)="previousPage()" [ngClass]="{'disableBtn': currentPage==1}">&lt;</li>
            <li class="fs-24 cp" (click)="nextPage()" [ngClass]="{'disableBtn': currentPage== gridData.totalNoOfPages}">
              &gt;</li>
          </ion-row>
        </ul>
      </ion-col>
      <div class="clear100"></div>
      <div class="clear20"></div>
    </ion-grid>
  </div>
</ion-content>